(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("siteheader", ["jquery", "betteroffcanvas"], factory);
    } else {
        // Browser globals
        root.siteheader = factory(root.jQuery, root.betteroffcanvas);
    }
}(this, function ($, betteroffcanvas, ajaxCart, Handlebars) {
    "use strict";
    "feel good";

    $("#activate-search i").click(function (e) {
        var $this = $(this);
        e.stopPropagation();
        $this.parents('header.fl-builder-content').find('.custom-search-style').addClass('manipulate-search-items');
    });
    $(".custom-search-style input[type='search']").click(function (e) {
        e.stopPropagation();
    });
    $(document).on('click', function() {
        $('.custom-search-style').removeClass('manipulate-search-items');
    })

}));
